import {forwardRef, HTMLInputAutoCompleteAttribute, InputHTMLAttributes} from "react";
import {useFormContext} from "react-hook-form";
import {ValidationViolation} from "./ValidationViolation.tsx";
import {FormGroup} from "./FormGroup.tsx";
import {useHasViolation} from "./useHasViolation.ts";
import {v4} from "uuid";


type BasicInputProps = {
    type: 'text',
    placeholder?: string,
    label: string,
    name: string,
    autoComplete?: HTMLInputAutoCompleteAttribute,
    violations?: Array<string>
} & InputHTMLAttributes<HTMLInputElement>


type ConnectedInputProps = BasicInputProps & {}

export const Input = forwardRef<HTMLInputElement, BasicInputProps>((props, ref) => {

    const {type, placeholder, label, name, violations, ...other} = props

    let id = props.id

    if (id === undefined || id === null) {
        id = v4()
    }

    return (
        <FormGroup>
            <label htmlFor={id}>{label}</label>
            <input ref={ref} type={type} className="form-control" id={id}
                   placeholder={placeholder} name={name} {...other}/>
            <ValidationViolation violations={violations}/>
        </FormGroup>
    )
})


export const ConnectedInput = ({type, autoComplete, placeholder, name, ...props}: ConnectedInputProps) => {
    const {register} = useFormContext()

    const id = `form_id__${name}`

    const {hasViolation, violations} = useHasViolation(name)

    return (
        <>
            <FormGroup hasViolation={hasViolation}>
                <label htmlFor={id}>{props.label}</label>
                <input type={type} className="form-control" id={id}
                       placeholder={placeholder}
                       autoComplete={autoComplete} {...register(name)}/>
                <ValidationViolation violations={violations}/>
            </FormGroup>
        </>
    )
}